import {
  CALLOUT_ASSET_GRID_CLASS_MAP,
  CALLOUT_COPY_COLUMN_CLASS_MAP,
  CALLOUT_ORIENTATION_GRID_CLASS_MAP,
  type TCalloutAsset,
  type TCalloutOrientation,
} from "./Callout.config";
import { isCalloutAssetImage } from "./Callout.guards";

export const getCalloutAssetGridClass = (
  asset: TCalloutAsset | undefined,
) => {
  if (asset && isCalloutAssetImage(asset)) {
    return CALLOUT_ASSET_GRID_CLASS_MAP.withImage;
  }

  return CALLOUT_ASSET_GRID_CLASS_MAP.default;
};

export const getCalloutOrientationGridClass = (
  orientation: TCalloutOrientation | undefined,
) => {
  if (!orientation) {
    return CALLOUT_ORIENTATION_GRID_CLASS_MAP.default;
  }

  return CALLOUT_ORIENTATION_GRID_CLASS_MAP[orientation];
};

export const getCalloutCopyColumnClass = (
  asset: TCalloutAsset | undefined,
) => (
  asset ?
    CALLOUT_COPY_COLUMN_CLASS_MAP.withAsset :
    CALLOUT_COPY_COLUMN_CLASS_MAP.default
);
